import { render, staticRenderFns } from "./AssistTeacherSelect.vue?vue&type=template&id=83524264&"
import script from "./AssistTeacherSelect.vue?vue&type=script&lang=js&"
export * from "./AssistTeacherSelect.vue?vue&type=script&lang=js&"
import style0 from "./AssistTeacherSelect.vue?vue&type=style&index=0&id=83524264&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports